import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { getSiteConfig } from "../lib/api";

/**
 * Injects the Google Search Console verification meta tag into every page's <head>.
 * The tag value lives in MongoDB (set via /admin/seo-tools); this component fetches
 * it once at app mount and caches it in sessionStorage to avoid extra requests.
 */
export default function SiteVerification() {
  const [tag, setTag] = useState(() => {
    try { return sessionStorage.getItem("oaa_gsc_tag") || ""; } catch { return ""; }
  });

  useEffect(() => {
    let cancelled = false;
    getSiteConfig()
      .then((cfg) => {
        if (cancelled) return;
        const v = cfg?.verification_tag || "";
        setTag(v);
        try { sessionStorage.setItem("oaa_gsc_tag", v); } catch { /* storage may be disabled */ }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!tag) return null;
  return (
    <Helmet>
      <meta name="google-site-verification" content={tag} />
    </Helmet>
  );
}
